// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LocaleResourceManager } from '../manager/locale-resource.manager';
import { CustomValidators } from '../custom-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'app-copy-from',
  templateUrl: './copy-from.component.html'
})
export class CopyFromComponent implements OnInit {

  @Output() public finish = new EventEmitter<string>();
  @Input() public calledBy: string;

  public form: FormGroup;
  public titleString: string = '';

  constructor(private bsModalRef: BsModalRef, private fb: FormBuilder, private localeResourceManager: LocaleResourceManager) { }

  ngOnInit() {
    this.form = this.fb.group({
      'source': new FormControl('', CustomValidators.trimRequired)
    });
    switch (this.calledBy) {
      case 'accessory': this.titleString = 'manageAccessories.header.copyAccessoriesFrom';
        break;
      case 'properties': this.titleString = 'copyPropertiesModal.title';
        break;
      case 'endplate': this.titleString = 'manageEndPlates.title.copyFrom';
        break;
      default: break;
    }
  }

  public getInputError(c: AbstractControl): string {
    if (c && c.hasError('messageKey')) {
      return this.localeResourceManager.getValueByKey(c.getError('messageKey'), { 0: c.getError('param') });
    } else {
      return '';
    }
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public save(): void {
    this.finish.emit(this.form.controls.source.value);
    this.close();
  }
}
